import {
    ESubscribedAddonStatus,
    IActiveAddon,
    IOngoingAddon,
    ISubscribedAddon,
    ITerminatedAddon,
} from "./interface/IAddonDetails";
import { EADDRESS_TYPES } from "@constants";
import { countyFormatter } from "@common/Eircode/utils/countyFormatter";
import { IContactAddress } from "@common/Eircode/interface/IAddressForm";

export const isOngoingAddon = (addon?: ISubscribedAddon): addon is IOngoingAddon =>
    addon?.status === ESubscribedAddonStatus.INITIAL;

export const isActiveAddon = (addon?: ISubscribedAddon): addon is IActiveAddon =>
    addon?.status === ESubscribedAddonStatus.ACTIVE;

export const isTerminatedAddon = (addon?: ISubscribedAddon): addon is ITerminatedAddon =>
    addon?.status === ESubscribedAddonStatus.TERMINATED;

const acceptedAddressTypes: EADDRESS_TYPES[] = [EADDRESS_TYPES.BILLING, EADDRESS_TYPES.DELIVERY];

export const filterAddresses = (contactAddressList: IContactAddress[]): IContactAddress[] =>
    contactAddressList
        .filter((address) => acceptedAddressTypes.includes(address.type))
        .sort((a, b) => Number(a.type !== EADDRESS_TYPES.DELIVERY) - Number(b.type !== EADDRESS_TYPES.DELIVERY));

export const areTwoSameAddresses = (contactAddressList: IContactAddress[]): boolean => {
    if (contactAddressList.length !== 2) {
        return false;
    }

    const [address1, address2] = contactAddressList;
    const IGNORED_KEYS: (keyof IContactAddress)[] = ["id", "type"];

    return (Object.keys(address1) as (keyof IContactAddress)[]).every((key) => {
        if (IGNORED_KEYS.includes(key)) {
            return true;
        }

        const value1 = address1[key];
        const value2 = address2[key];

        // both prop values are missing => true
        if (!value1 && !value2) {
            return true;
        }

        // both prop values are present => must compare
        if (value1 && value2) {
            return value1 === value2;
        }

        // one present, one missing => false except for the `code` prop
        return key === "code";
    });
};

export const transformAddress = (address: IContactAddress) =>
    [
        address.addressLine1,
        address.addressLine2,
        address.addressLine3,
        address.town,
        countyFormatter(address.county),
        address.code,
    ]
        .filter(Boolean)
        .join(", ");
